import { Devis } from '@/models/Devis';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { InterventionNonPreventive } from '@/models/InterventionNonPreventive';
import dayjs from 'dayjs';

export interface SuiviDevisState {
    devis: Devis[];

    tableHeader: TableHeader[];

    page: number;
    count: number;
    nbOfPages: number;
    scroll: number;

    sort: {
        sortData: string;
        sortStatus: SortType;
    };
    filterSite: number[];
    filterStatus: string[];
    filterDevisId: string;
    filterNumero: string;
    filterNumFactures: string;
    filterDateDebut: string;
    filterDateFin: string;
    isLoading: boolean;
    error?: Error;
    success: boolean;

    bonDeCommandeFile: File[];

    isExportXlsLoading: boolean;

    interventions: InterventionNonPreventive[];

    tableHeaderInterventions: TableHeader[];

    pageInterventions: number;
    nbOfPagesInterventions: number;
    scrollInterventions: number;
    countInterventions: number;

    sortInterventions?: {
        sortDataInterventions: string;
        sortStatusInterventions: SortType;
    };

    filterStatusInterventions: Array<string>;
    filterInterventionId: string;
    filterPredictedDateFrom: string;
    filterPredictedDateTo: string;

    isLoadingInterventions: boolean;
    errorInterventions?: Error;
    successInterventions: boolean;
}

export const initialState: SuiviDevisState = {
    devis: [],
    sort: {
        sortData: 'dateChiffrage',
        sortStatus: SortType.DESC,
    },
    tableHeader: [
        {
            label: 'devis.id',
            sortData: 'numero',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'devis.object',
            sortData: 'objet',
            sortStatus: SortType.NONE,
            width: '28%',
        },
        {
            label: 'devis.numero',
            sortData: 'numCommande',
            sortStatus: SortType.INACTIVE,
            width: '14%',
        },
        {
            label: 'devis.demande.id',
            sortData: 'demandeDevisId',
            sortStatus: SortType.NONE,
            width: '7%',
            regleCle: 'suiviDevis.demandeLiee',
        },
        {
            label: 'devis.prix',
            sortData: 'prix',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'devis.montantFacture',
            sortData: 'montantFacture',
            sortStatus: SortType.NONE,
            width: '10%',
            regleCle: 'suiviDevis.facturation',
        },
        {
            label: 'devis.numFactures',
            sortData: 'factures.numero',
            sortStatus: SortType.INACTIVE,
            width: '11%',
        },
        {
            label: 'devis.datePublication',
            sortData: 'dateChiffrage',
            sortStatus: SortType.DESC,
            width: '11%',
        },
        {
            label: 'devis.etatDevis',
            sortData: 'etatDevis',
            sortStatus: SortType.NONE,
            width: '10%',
            regleCle: 'suiviDevis.statuts',
        },
    ],

    page: 0,
    count: 0,
    nbOfPages: 0,
    scroll: 0,

    filterSite: [],
    filterStatus: ['PUBLIE'],
    filterDevisId: '',
    filterNumero: '',
    filterNumFactures: '',
    filterDateDebut: dayjs().add(-3, 'month').format('YYYY-MM-DD'),
    filterDateFin: dayjs().format('YYYY-MM-DD'),
    isLoading: false,
    success: false,

    bonDeCommandeFile: [],

    isExportXlsLoading: false,

    interventions: [],

    tableHeaderInterventions: [
        {
            label: 'intervention.id',
            sortData: 'id',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'intervention.objet',
            sortData: 'objet',
            sortStatus: SortType.NONE,
            width: '24%',
        },
        {
            label: 'intervention.dateDebutPrevue',
            sortData: 'dateDebutPrevue',
            sortStatus: SortType.DESC,
            width: '10%',
        },
        {
            label: 'intervention.dateFin',
            sortData: 'dateFinReelle',
            sortStatus: SortType.NONE,
            width: '9%',
        },
        {
            label: 'intervention.request.status',
            sortData: 'etat',
            sortStatus: SortType.NONE,
            width: '9%',
        },
    ],

    pageInterventions: 0,
    nbOfPagesInterventions: 0,
    scrollInterventions: 0,
    countInterventions: 0,

    sortInterventions: {
        sortDataInterventions: 'dateDebutPrevue',
        sortStatusInterventions: SortType.DESC,
    },

    filterStatusInterventions: [],
    filterInterventionId: '',
    filterPredictedDateFrom: dayjs().add(-1, 'y').format('YYYY-MM-DD'),
    filterPredictedDateTo: dayjs().format('YYYY-MM-DD'),

    isLoadingInterventions: false,
    successInterventions: false,
};

export const state: SuiviDevisState = {
    ...initialState,
};
